// Loga info do deploy no console ao ser importado (side-effect) — apenas em dev/homolog.
// Producao nao tem .env -> VUE_APP_AMBIENTE indefinido -> nao loga nada.
// branch e ultimoDeploy vem dos exports VUE_APP_BRANCH/VUE_APP_DEPLOY_TIME no deploy.sh.
if (process.env.VUE_APP_AMBIENTE) {
    console.log('f-erp', {
        branch: process.env.VUE_APP_BRANCH || '-',
        ultimoDeploy: process.env.VUE_APP_DEPLOY_TIME || '-',
    })
}
